import { Redirect } from 'expo-router'

export default function TableTourEmbeddedRedirect() {
  return <Redirect href="/game/table-tour" />
}
